"use client"

import React, { useEffect, useRef, useState } from "react"
import { Animated, Image, useWindowDimensions } from "react-native"
import { styled, StyledProps } from "nativewind"
import { twMerge } from "tailwind-merge"

const StyledImage = styled(Animated.createAnimatedComponent(Image))

type Props = StyledProps<{
  src: string
  alt?: string
}>

const AnimatedImage = (props: Props) => {
  const [aspectRatio, setAspectRatio] = useState(1)
  const opacity = useRef(new Animated.Value(0)).current
  const translateY = useRef(new Animated.Value(25)).current
  Image.getSize(props.src, (width, height) => {
    setAspectRatio(width / height)
  })
  const { width } = useWindowDimensions()

  useEffect(() => {
    Animated.timing(opacity, {
      toValue: 1,
      duration: 1000,
      useNativeDriver: true,
    }).start()
    Animated.timing(translateY, {
      toValue: 0,
      duration: 1000,
      useNativeDriver: true,
    }).start()
  }, [])

  const classes = twMerge(
    "w-[400px] md:w-[450px] overflow-hidden rounded-lg",
    props.className,
  )
  return (
    <StyledImage
      alt={props.alt || ""}
      source={{ uri: props.src }}
      className={classes}
      resizeMode="contain"
      style={{
        aspectRatio,
        opacity,
        transform: [{ translateY }],
        maxWidth: width * 0.8,
      }}
    />
  )
}

export default AnimatedImage
